import React, { useMemo } from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import { createAvatarName, SanitizedHtml } from "../../../../../utils";
import arrow from "../../../../../styles/svg/arrow.svg"
import { formatDateMMDDYY } from "../../../../../utils/helpers";
import { useFeedActorMeta } from "../hooks/useFeedActorMeta";
import { useFeedBoardMeta } from "../hooks/useFeedBoardMeta";

function FeedHistory({ history, boardName, isDueDate = false, hideDetails = false }) {
  const { actor, avatarStyles, formattedDate, isMobile } = useFeedActorMeta({
    user: history?.response_object?.user_object,
    date: history?.at_time,
  });
  const {
    boardKeyDisplay,
    boardName: boardTitle,
    openBoard,
    openCard,
  } = useFeedBoardMeta(boardName, history?.card_id);


  if (!history) return null;

  const value = history?.response_object?.old_key;
  const result = (Array.isArray(value) ? value.length > 0 : value) ? value : "None";

  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: isMobile
          ? "calc(100% - 10px) !important"
          : "calc(100% + 16px) !important",
      }}
      className="worklog-item d-flex justify-content-space-between"
    >
      <Grid
        item
        xs={isMobile ? 12 : 9}
        sx={{ paddingLeft: isMobile && "8px !important" }}
      >
        <div className="d-flex w-100">
          <Avatar
            username={actor.username}
            user_image={actor.userImage}
            title={actor.username}
            className="user-avtar-dropdown user-avatar mr-8"
            style={avatarStyles}
          >
            {createAvatarName(actor.username)}
          </Avatar>
          <div className="w-100">
            <div className="d-flex justify-content-space-between ">
              <div className={"d-flex align-items-center"}>
                <div>
                    <Tooltip
                    title={boardTitle}
                  >
                    <a
                      className="board-anquor cursor-pointer underline"
                      onClick={openBoard}
                    >
                      {boardKeyDisplay}
                    </a>
                  </Tooltip>
                  -
                  <a
                    className="board-anquor cursor-pointer mr-1 underline"
                    onClick={openCard}>
                    {history?.card_id}:
                  </a>
                </div>
                <p className="worklog-title mr-2">
                  {actor.username}
                </p>
              </div>
            </div>
            <SanitizedHtml
              as="div"
              className="worklog-worklog comment-content"
              html={history?.history_text}
            />
            {history?.response_object?.old_allocated_hours && <div className="d-flex align-items-center history-heading">
              <div className="old-status-box">
                <p className="old-status">{history?.response_object?.old_allocated_hours}</p>
              </div>
              <img className="arrow-img" src={arrow} alt="" />
              <div className="new-status-box">
                <p className="new-status">{history?.response_object?.updated_allcated_hours}</p>
              </div>
            </div>}

            {!hideDetails && (isDueDate ?
              <div className="d-flex align-items-center history-heading">
                <div>
                  <p>{result === 'None' ? 'None' : formatDateMMDDYY(result)}</p>
                </div>
                <img className="arrow-img" src={arrow} alt="" />
                <div>
                  <p>{formatDateMMDDYY(history?.response_object?.new_key) || "None"}</p>
                </div>
              </div>
              :
              (history?.response_object?.new_key || history?.response_object?.old_key) &&
              <div className="d-flex align-items-center history-heading">
                {history?.response_object?.old_key && <div >
                  <SanitizedHtml as="div" html={result} />
                </div>}
                {history?.response_object?.old_key && history?.response_object?.new_key && <img className="arrow-img" src={arrow} alt="" />}
                <div>
                  <SanitizedHtml as="div" html={history?.response_object?.new_key} />
                </div>
              </div>)
            }

          </div>
        </div>
      </Grid>
      <Grid
        item
        xs={isMobile ? 12 : 3}
        sx={{ paddingTop: isMobile && "0px !important" }}
      >
        <div className={"right-details d-flex"}>
          <p className="worklog-date-time comment-date comment">
            Updated on{" "}
          </p>
          <p className="worklog-date-time comment-date">
            {/* {!sameDay && <img src={lateIcon} className="late-icon" />} */}
            {formattedDate}
          </p>
        </div>
      </Grid>
    </Grid>
  )
}

export default React.memo(FeedHistory);
